import React, { createContext, useState } from 'react';

export const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [docMenuItems, setDocMenuItems] = useState([]);
  const [docSubMenuItems, setDocSubmenuItems] = useState([]);
  const [handleMenuItemClick, setHandleMenuItemClick] = useState(null);
  const [handleSubMenuItemClick, setHandleSubMenuItemClick] = useState(null); 
  const [handleMenuItemDbClick, setHandleMenuItemDbClick] = useState(null); 
  const [handleMenuAllItemClick, setHandleMenuAllItemClick] = useState(null);




  return (
    <MenuContext.Provider value={{ docMenuItems, setDocMenuItems, docSubMenuItems, setDocSubmenuItems, handleMenuItemClick, setHandleMenuItemClick, handleSubMenuItemClick, setHandleSubMenuItemClick, handleMenuItemDbClick, setHandleMenuItemDbClick, handleMenuAllItemClick, setHandleMenuAllItemClick }}>
      {children}
    </MenuContext.Provider>
  );
};